import SectionHeader from 'components/sectionHeader/SectionHeader';
import { useTranslation } from 'react-i18next';
import AddReviewTemplateButton from './add/AddReviewTemplateButton';
import { GuestReviewTemplatesContainer } from './GuestReviewTemplates.styles';
import GuestReviewTemplatesTable from './table/GuestReviewTemplatesTable';

const GuestReviewTemplatesSection = () => {
  const { t } = useTranslation();

  return (
    <GuestReviewTemplatesContainer>
      <SectionHeader
        title={t('pageAutomations.reviews.guestReviewTemplates.title')}
        id="guest-review-templates"
        subtitle={t('pageAutomations.reviews.guestReviewTemplates.subtitle')}
        tooltip={t(
          'pageAutomations.reviews.guestReviewTemplates.headerTooltip',
        )}
        buttons={<AddReviewTemplateButton />}
      />

      <GuestReviewTemplatesTable />
    </GuestReviewTemplatesContainer>
  );
};

export default GuestReviewTemplatesSection;
